module.exports = __webpack_public_path__ + "d308073b/img/comment-question-icon.7dd26e04.svg";